import { useCallback } from 'react'
import { useToast } from '../contexts/ToastContext'
import { useOverlay } from '../contexts/OverlayContext'
import { ToastMessage } from 'primereact/toast'
import { TOAST_TIME_TIME } from '../shared/constants'

type ApiCallType = {
  try: (toast: (options: ToastMessage | ToastMessage[]) => void) => Promise<void>
  catch?: (error: any) => void
  finally?: () => Promise<void>
  loading?: boolean
}

export function useApi() {
  const { show } = useToast();
  const { showLoading, hideLoading } = useOverlay();

  const call = useCallback(
    async ({
      try: callbackCall,
      finally: callbackFinally,
      catch: callbackCatch,
      loading = false,
    }: ApiCallType) => {
      try {
        if (loading) showLoading();

        await callbackCall(show)
      } catch (e) {
        const axiosError = e as any

        if (callbackCatch) {
          callbackCatch(axiosError)
        }

        if (axiosError?.response?.data?.userMessage) {
          show({
            severity: 'error',
            summary: axiosError?.response?.data?.title,
            detail: axiosError?.response?.data?.userMessage,
            life: TOAST_TIME_TIME
          })
        }
      } finally {
        callbackFinally?.()
        if (loading) hideLoading();
      }
    },
    [hideLoading, showLoading, show],
  )

  return { call }
}
